import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import Slider from 'react-slick'
import LazyLoad from 'react-lazyload'

import { fetchCategories } from 'ducks/categories'
import useLocalStorage from '@/modern/hooks/useLocalStorage'

import PlaceHolder from 'components/PlaceHolder'
import CategoryCard from './components/CategoryCard'
import Section from '../Section'

export const defaultSettings = {
  dots: false,
  infinite: false,
  slidesToShow: 6,
  responsive: [
    {
      breakpoint: 1930,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1680,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 1368,
      settings: {
        slidesToShow: 4,
      },
    },
  ],
}

const Categories = ({ id, customSettings, origin }) => {
  const dispatch = useDispatch()
  const { result, status } = useSelector(state => state.categoriesState)
  const [fairCategories, setFairCategories] = useLocalStorage(
    'wbFairCategories',
    []
  )

  const filterActiveCustomCategories = ({ showUntil }) => {
    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)
    const limitDate = new Date(`${showUntil}T23:59:59`)

    return limitDate >= startOfToday
  }

  const activeFairs = fairCategories.filter(filterActiveCustomCategories)

  const isLoading = status === 'idle' || status === 'pending'
  const isResolved = status === 'resolved'
  const isRejected = status === 'rejected'

  const placeholders = [...Array(6).keys()]

  const categories = result.filter((category, i) => i < 10)

  const settings = {
    ...defaultSettings,
    ...customSettings,
  }

  React.useEffect(() => {
    dispatch(fetchCategories())
  }, [dispatch])

  React.useEffect(() => {
    const getFairCategories = () =>
      setFairCategories(window.wbFairCategories || [])

    document.addEventListener('wbFairCategoriesUpdate', getFairCategories)

    return () => {
      document.removeEventListener('wbFairCategoriesUpdate', getFairCategories)
    }
  }, [setFairCategories])

  if (isRejected) return null

  return (
    <LazyLoad height={322}>
      <Section
        id={id}
        className="CarouselContainer container"
        title="Categorias"
      >
        <Slider {...settings}>
          {isLoading &&
            placeholders.map(item => (
              <div key={item} className="slick-padding">
                <PlaceHolder style={{ height: 190 }} />
              </div>
            ))}

          {isResolved &&
            activeFairs.map(({ background, title, url, target }, index) => (
              <div key={index} className="slick-padding">
                <CategoryCard
                  category={{
                    slug: '',
                    background: background || '',
                title,
                url,
                target,
                  }}
                />
              </div>
            ))}

          {categories.map(({ Categoria, Nome, CardDesktop, Url }) => (
            <div key={Categoria} className="slick-padding">
              <CategoryCard
                category={{
                  background: CardDesktop || '',
                  title: Nome,
                  slug: Url,
                }}
                origin={origin}
              />
            </div>
          ))}
        </Slider>
      </Section>
    </LazyLoad>
  )
}

Categories.defaultProps = {
  customSettings: {},
  origin: null,
}

Categories.propTypes = {
  id: PropTypes.string.isRequired,
  customSettings: PropTypes.object,
  origin: PropTypes.string,
}

export default Categories
